import { useCallback, useEffect, useMemo, useState } from 'react';

import { AdminPermissions } from 'constants/admin-permissions';

import { useLazyGetAllUsersQuery } from 'api/user-api';

export const useSupportUserNames = () => {
  const [getUsers] = useLazyGetAllUsersQuery();

  const [supportUsers, setSupportUsers] = useState([]);

  useEffect(() => {
    getUsers({ with_admin_permissions: [AdminPermissions.ProcessCandidateChecks], records: 1000 })
      .unwrap()
      .then(({ result }) => {
        setSupportUsers(result.users);
      });
  }, []);

  const supportUserNames = useMemo(() => {
    return (
      supportUsers?.reduce((acc, user) => {
        acc[user.id] = `${user.first_name || ''} ${user.last_name || ''}`.trim();
        return acc;
      }, {}) || {}
    );
  }, [supportUsers]);

  const getSupportUser = useCallback(
    supportUserId => {
      return supportUserNames[supportUserId] || '';
    },
    [supportUserNames],
  );

  return {
    supportUserNames,
    getSupportUser,
    supportUsers,
  };
};
